import { drivelabels_v2 } from '@googleapis/drivelabels';

type Label = drivelabels_v2.Schema$GoogleAppsDriveLabelsV2Label;

export type LabelLifecycleStatus =
  | 'PUBLISHED'
  | 'PUBLISHED_NEW_DRAFT'
  | 'DRAFT'
  | 'DISABLED'
  | 'UNKNOWN';

export function getLabelLifecycleStatus(label: Label): LabelLifecycleStatus {
  const normalized = String(label?.lifecycle?.state ?? '')
    .trim()
    .toLowerCase();

  if (normalized === 'published') {
    return label.lifecycle?.hasUnpublishedChanges
      ? 'PUBLISHED_NEW_DRAFT'
      : 'PUBLISHED';
  }
  if (normalized === 'unpublished_draft') return 'DRAFT';
  if (normalized === 'disabled') return 'DISABLED';
  return 'UNKNOWN';
}

const STATUS_TEXT: Record<LabelLifecycleStatus, string> = {
  PUBLISHED: 'Published',
  PUBLISHED_NEW_DRAFT: 'Published, new draft',
  DRAFT: 'Draft',
  DISABLED: 'Disabled',
  UNKNOWN: '--',
};

/** The label's status as Label Manager words it, e.g. "Published, new draft". */
export function getLabelStatusText(label: Label): string {
  return STATUS_TEXT[getLabelLifecycleStatus(label)];
}
